import styled from 'styled-components';

interface Props {
  type?: 'industry' | 'company';
}

export const TickerSymbol = styled('b')<Props>`
  margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
  color: ${({ theme }) => theme.color.brand01};
`;

export const Name = styled('span')`
  ${({ theme }) => theme.typography.tiny}
`;

export const Industry = styled('td')`
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  > span {
    ${({ theme }) => theme.typography.xSmall}
  }
`;

export const Company = styled('td')`
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  max-width: 180px;
`;
